import * as React from 'react';
import { Scroller, Slider, Image, Overlay, Buttons, PaginationFraction } from '@cian/slider';
import { PaginationDots } from './components/PaginationDots';
import * as styles from './Carousel.css';

interface ICarouselProps {
  images: string[];
  deviceType?: 'desktop' | 'mobile';
}

export const Carousel: React.FC<ICarouselProps> = ({ images, deviceType = 'desktop' }) => {
  return (
    <Slider loop={deviceType === 'desktop'}>
      <Scroller>
        {images.map((image, index) => (
          <div key={`slide_${index}`} className={styles['slide']}>
            <Image src={image} />
          </div>
        ))}
      </Scroller>
      <Overlay hideable={deviceType === 'desktop'}>
        {deviceType === 'desktop' && <Buttons />}
        {deviceType === 'desktop' ? <PaginationFraction /> : <PaginationDots />}
      </Overlay>
    </Slider>
  );
};
